import { css } from '@/styled-system/css';

export const label = css({
  fontSize: 'sm',
  lineHeight: 'sm',
  color: 'hpxGrey600',
  display: 'block',
  marginBottom: 'xs',
  userSelect: 'none',
});

export const labelDisabled = css({
  opacity: 0.5,
  cursor: 'not-allowed',
});
